import { ItemsAggregateMemory, SentencesAggregateMemory } from 'es6/models/domain-aggregate-memory';

export default class AggregateMemory {
  constructor(attrs = {}) {
    _.defaults(this, attrs, {
      goalId: null,
      completed: false,
      focused: false,
      enrolled: null,
      startedAt: null,
      completedAt: null,
      items: null,
      sentences: null,
    });

    if (this.items && !(this.items instanceof ItemsAggregateMemory)) {
      this.items = new ItemsAggregateMemory(this.items, this.completed);
    }

    if (this.sentences && !(this.sentences instanceof SentencesAggregateMemory)) {
      this.sentences = new SentencesAggregateMemory(this.sentences);
    }
  }

  /**
   * Sets the enrolled flag (and other consequential flags).
   *
   * @param {Boolean} toggle
   */
  setEnrolled(toggle) {
    if (!toggle) {
      this.focused = false;
    }

    this.enrolled = toggle;
  }

  /**
   * Sets the focused flag (and other consequential flags).
   *
   * @param {Boolean} toggle
   */
  setFocused(toggle) {
    if (toggle) {
      this.enrolled = true;
    }

    this.focused = toggle;
  }
}
